import Select, { TSelect } from "../gui/Select/Select";
import RowsCache from "../jslibs/RowsCache";
import FManApi from "./FManApi";

export type TUsername = TSelect<string> 
    
export default class Usernames extends RowsCache<TUsername> {
    static _i:Usernames
    static get i(){
        if (!this._i) this._i = new Usernames()
        return this._i
    }

    constructor(){
        super("unames", 0)
    }

    async fetch(){
        const all = await FManApi.i.getUsernames().then(users => users.map(user => ({text:user.name,id:user._id})))
        all.push({id:"admin",text:"root"})
        all.push({id:"",text:"everyone"})
        return all
    }

    key(row: TUsername): string {
        return Select.id(row)
    }
}